import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';

import { ToastrTypes } from '@app/entities/toastr';
import { ErrorTypes } from '@reservation/constants/error.constants';
import { fetchMessageAction } from '@app/store/actions/global.actions';

@Injectable()
export class ErrorService {

  constructor(
    private translateService: TranslocoService) { }

  get textError(): string {
    return this.translateService.translate('ERROR_REQUEST');
  }

  get duplicateMessage(): string {
    return this.translateService.translate('BOOKING_MODULE.ERRORS.DUPLICATE');
  }

  public displayErrorMessage(err: HttpErrorResponse): Action {
    const { error } = err;
    const errorMessage = error?.message ? error.message : typeof error === 'string' ? error : '';
    const isDuplicateError = this.isDuplicateMessage(errorMessage);
    const message = isDuplicateError ? this.duplicateMessage : this.textError;
    const type = isDuplicateError ? ToastrTypes.WARNING : ToastrTypes.ERROR;
    return fetchMessageAction({ toastr: { message, type } });
  }

  private isDuplicateMessage(mesagge: string): boolean {
    return !!mesagge && (mesagge.includes(ErrorTypes.DUPLICATE_KEY) || mesagge.includes(ErrorTypes.EXIST_REGISTER));
  }

}
